import React, { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
  onBranchSearch,
  onProjectSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import { sumBy, uniq } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import numberFormatInt from "../../utils/numberFormatInt";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  CANCELLED,
  OPEN,
  STATUS_CLOSED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
import StockFormModal from "../modals/StockFormModal";
import computeItemDetails from "../../utils/computeItemDetails";
const { Content } = Layout;
const { Panel } = Collapse;

const transaction = "internal-repairs";
const url = `/api/${transaction}/`;
const title = "Internal Repair Form";

const initialItemValues = {
  stock: "",
  quantity: "",
  price: "",
  amount: "",
  supplier: "",
  notes: "",
  estimate_quantity: 0,
  total_withdrawn_quantity: 0,
  inventory_quantity: 0,
};

const transaction_counter = {
  label: "EST #",
  key: "estimate_no",
};

const date_fields = ["date", "deadline"];

export default function InternalRepairForm({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const [page_size, setPageSize] = useState(100);

  const [loading, setLoading] = useState(false);
  const accountFormModal = useRef(null);
  const stockFormModal = useRef(null);
  const warehouseFormModal = useRef(null);
  const caseQuantityField = useRef(null);
  const quanttiyField = useRef(null);
  const casePriceField = useRef(null);
  const priceField = useRef(null);
  const amountField = useRef(null);
  const addItemButton = useRef(null);
  const stockField = useRef(null);

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [
      {
        ...initialItemValues,
      },
    ],
    discounts: [],

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,

    gross_amount: 0,
    total_discount_amount: 0,
    total_amount: 0,
  };
  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "Doc #",
      dataIndex: "doc_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Account",
      dataIndex: ["account", "name"],
    },
    {
      title: "Remarks",
      dataIndex: ["remarks"],
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
  ];

  const items_column = [
    {
      title: "Item",
      dataIndex: ["stock"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={stock?.name}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const stock = options.stocks?.[index] || null;

                if (stock) {
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index].stock = stock;

                    if (items.length - 1 === record_index) {
                      items.push({
                        ...initialItemValues,
                        category: items[record_index].category,
                      });
                    }

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
              onAddItem={() => stockFormModal.current.open(record_index)}
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },

    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    if (state._id && state.project?._id) {
      axios
        .post(`/api/project-estimates/get-quantities/${state.project?._id}`)
        .then((response) => {
          if (response.data) {
            const update_items = state.items.map((item) => {
              const match_item = response.data.find(
                (record) => record._id.toString() === item.stock._id?.toString()
              );

              if (match_item) {
                return {
                  ...item,
                  estimate_quantity: match_item.estimate_quantity,
                  total_withdrawn_quantity: match_item.total_withdrawn_quantity,
                  inventory_quantity: match_item.inventory_quantity,
                };
              }

              return item;
            });

            setState((prevState) => ({
              ...prevState,
              items: update_items,
            }));
          }
        })
        .catch((err) => console.log(err));
    }
  }, [state._id]);

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    (async () => {
      if (isEmpty(params?.id) && !isEmpty(search_state.branch?._id)) {
        setTimeout(() => {
          onSearch({
            page: current_page,
            page_size,
            search_keyword,
            url,
            setRecords,
            setTotalRecords,
            setCurrentPage,
            setErrors,
            advance_search: { ...search_state },
          });
        }, 300);
      }
    })();

    return () => {};
  }, [search_state.branch]);

  useEffect(() => {
    setState((prevState) => {
      const total_amount = sumBy(state.items, (o) => o.amount);
      const gross_amount = total_amount;
      let net_amount = gross_amount;

      (state.discounts || []).forEach((discount) => {
        let discount_rate = validator.isNumeric(discount.toString())
          ? 1 - round(discount) / 100
          : 1;

        net_amount = net_amount * discount_rate;
      });

      const total_discount_amount = round(gross_amount - net_amount);

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
      };
    });

    return () => {};
  }, [state.items, state.discounts]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  const can_edit =
    isEmpty(state.status) || [OPEN].includes(state.status?.approval_status);

  return (
    <Content className="content-padding">
      <StockFormModal
        setField={(stock, index) => {
          setState((prevState) => {
            const items = [...prevState.items];
            items[index].stock = stock;

            if (items.length - 1 === index) {
              items.push({
                ...initialItemValues,
              });
            }

            return {
              ...prevState,
              items,
            };
          });
        }}
        ref={stockFormModal}
      />
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                      items: [
                        {
                          ...initialItemValues,
                        },
                      ],
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>

                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onSupplierSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onSupplierSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[OPEN, STATUS_CLOSED, CANCELLED] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="DOC #"
                          name="doc_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state[transaction_counter.key]}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <TextFieldGroup
                          label="Reference"
                          name="reference"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.reference}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
          {/* <Col span={12} className="has-text-right">
            <Button
              type="link"
              onClick={() => {
                navigate("/cashier");
              }}
            >
              Go Back Cashiering
            </Button>
          </Col> */}
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                  items: state.items.filter((o) => !isEmpty(o.stock?._id)),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}
            <DatePickerFieldGroup
              label="Date"
              name="date"
              value={state.date || null}
              onChange={(value) => {
                onChange({
                  key: "date",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Supplier"
                  value={state.account?.name}
                  onFocus={() => {
                    onSupplierSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onSupplierSearch({ value, setOptions })}
                  onChange={(index) => {
                    const account = options.accounts?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      account,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.accounts}
                  column="name"
                  error={errors.account}
                  onAddItem={() => accountFormModal.current.open()}
                />
              </Col>
            </Row>

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />
            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Table
              dataSource={addKeysToArray([
                ...state.items,
                {
                  footer: 1,
                  quantity: sumBy(state.items, (o) => round(o.quantity)),
                  case_quantity: sumBy(state.items, (o) =>
                    round(o.case_quantity)
                  ),
                  amount: sumBy(state.items, (o) => round(o.amount)),
                },
              ])}
              columns={items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={() => {
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: { ...search_state },
                    });
                  },
                });
              }}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              }}
              onClose={() => {
                onUpdateStatus({
                  url,
                  state,
                  approval_status: STATUS_CLOSED,
                  user: auth.user,
                  cb: () => {
                    edit({
                      record: state,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                });
              }}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() =>
                window.open(`/print/${transaction}/${state._id}`, "_tab")
              }
              has_save={can_edit}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          items: [
                            ...record.items,
                            {
                              ...initialItemValues,
                            },
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
